var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4NonSmokingArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.32 34L32.49 46H67v8H23.89L0 76v-4.77l55.7-52.06L76 0v5.27l-20.28 19L45.32 34zm-26.61-2A6.7 6.7 0 0012 38.71V43h4v-4.29A2.71 2.71 0 0118.71 36h10.47c1.302 0 2.594-.223 3.82-.66a10.79 10.79 0 004.51-3 11 11 0 001.68-2.69A10.29 10.29 0 0040 25.5V25h-4v.5a6.33 6.33 0 01-1.56 4.2 6.9 6.9 0 01-5.2 2.3H18.71zM9 38.31C9 32.92 12.79 29 18 29h2.33A10.47 10.47 0 0031 18.5V16h-4v2.5a6.51 6.51 0 01-6.67 6.5h-2.87C10.32 25.3 5 30.91 5 38.31V43h4v-4.69zM12 54h.88l8.52-8H12v8zm-3-8H5v8h4v-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Non_smoking_area.79ff763b.svg";
export { SvgE4NonSmokingArea as ReactComponent };